module["exports"] = [
  "#{building_number} #{street_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/address/street_address.js
// module id = 2037
// module chunks = 2